<div class="admin-budget-meter">
    <cv-admin-budget-title-header [title]="sectionTitle" [btnTemplate]="exportBtn"></cv-admin-budget-title-header>
    <ng-template #exportBtn>
        <div>
            <sol-button [disabled]="isLoading || budget.budgetList.length === 0" id="export-btn" variant="basic" size="medium" [matMenuTriggerFor]="menu.menu">
                <span cvLocalizedText langSection="Budget_Setup" langKey="Export">Export</span>
            </sol-button>
            <sol-floating-menu #menu menuClass="export-menu-budget" [menuItems]="defaultMenuOptions" 
                spriteIconPath="../App_Themes/CXone/icons/export-menu-icons.svg" position="'bottom'"></sol-floating-menu>
        </div>
    </ng-template>
    <div class="admin-budget-meter__legend">
        <span>{{budgetMeterSectionTitle}}</span>
    </div>
    <div class="col-12 d-flex flex-row justify-content-center">
        <div>
            <div class="d-flex flex-row align-items-center">
                <svg class="icon-24 fill-valyrianSteel">
                    <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin"></use>
                </svg>
                <div class="color-theUpsideDown font-size-32 ml-1 lato-bold">
                    {{formatValue(totalBudget)}}
                </div>
            </div>
            <div class="color-valyrianSteel font-size-12 ml-4">
                <span cvLocalizedText langSection="Budget_Meter" langKey="Monthly_Total_Budget">Monthly Total
                    Budget</span>
            </div>
        </div>

        <div class="ml-5">
            <div class="d-flex flex-row align-items-center">
                <svg class="icon-24 fill-valyrianSteel">
                    <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin"></use>
                </svg>
                <div class="color-theUpsideDown font-size-32 ml-1 lato-bold">
                    {{formatValue(coinsAvailable)}}
                </div>
            </div>
            <div class="color-valyrianSteel font-size-12 ml-4">
                <span cvLocalizedText langSection="Budget_Meter" langKey="Coins_Available">Coins Available</span>
            </div>
        </div>
    </div>

    <!-- Main Budget Meter -->
    <div class="budget-overview-progress-component" style="line-height: 1;">
        <div class="row pt-5 pb-4">
            <div class="col-2 pr-0 text-right d-flex flex-column justify-content-end">
                <span class="lato-bold font-size-12">
                    {{totalBudget <= 0 ? '' : getBudgetPercentage(totalBudget, totalCoinsAwarded)}} </span>
                        <span class="font-size-12">
                            {{formatValue(totalCoinsAwarded)}}
                            <span cvLocalizedText langSection="Budget_Meter" langKey="Coins_Awarded"> Coins
                                Awarded</span>
                        </span>
            </div>
            <div class="col-8">
                <div class="d-flex justify-content-center w-100 mb-2" *ngIf="totalBudget <= 0">
                    <span class="bold" cvLocalizedText langSection="Budget_Meter" langKey="No_Budget_Assigned">No Budget
                        Assigned</span>
                </div>
                <div class="progress rounded-0" style="height:32px">
                    <div class="progress-bar progress-bar-animated"
                        [ngClass]="getProgressClass((totalCoinsAwarded/totalBudget) * 100)"
                        style="height:32px; transition: 0.3s all ease;"
                        [ngStyle]="{ 'width': (totalCoinsAwarded/totalBudget) * 100 + '%' }">
                    </div>
                </div>
            </div>
            <div class="col-2 pl-0 text-left d-flex flex-column justify-content-end">
                <span class="lato-bold font-size-12">
                    {{totalBudget <= 0 ? '' : getBudgetPercentage(totalBudget, totalBudget - totalCoinsAwarded)}}
                        </span>
                        <span class="font-size-12">
                            {{formatValue(getRemainingCoins(totalBudget, totalCoinsAwarded))}}
                            <span cvLocalizedText langSection="Budget_Meter" langKey="Remaining_Coins">Remaining
                                coins</span>
                        </span>
            </div>
        </div>
    </div>
    <!-- Group Budget Meter -->
    <div class="budget-overview-progress-component pt-3" *ngFor="let budgetGroup of budget.budgetList"
        [class.d-none]="!displayBudgetDetails" style="line-height: 1; border-top: 1px #D2D6DB solid;">
        <div class="row">
            <div class="col-6">
                <span class="admin-budget-meter-groups">
                    {{budgetGroup.GroupLevelName}}
                </span>
            </div>
            <div class="col-6 d-flex flex-row justify-content-end">
                <div class="ml-5">
                    <div class="d-flex flex-row align-items-center">
                        <svg class="icon-24 fill-valyrianSteel">
                            <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin"></use>
                        </svg>
                        <div class="color-theUpsideDown font-size-32 ml-1 lato-bold">
                            {{formatValue(budgetGroup.Amount)}}
                        </div>
                    </div>
                    <div class="color-valyrianSteel font-size-12 ml-4">
                        <span cvLocalizedText langSection="Budget_Meter" langKey="Monthly_Total_Budget">Monthly Total
                            Budget</span>
                    </div>
                </div>

                <div class="ml-5">
                    <div class="d-flex flex-row align-items-center">
                        <svg class="icon-24 fill-valyrianSteel">
                            <use href="../App_Themes/CXone/icons/gamification/coin.svg#coin"></use>
                        </svg>
                        <div class="color-theUpsideDown font-size-32 ml-1 lato-bold">
                            {{availableBudget(budgetGroup.Amount - budgetGroup.CoinsAwarded) | cvNumberLocalize }}
                        </div>
                    </div>
                    <div class="color-valyrianSteel font-size-12 ml-4">
                        <span cvLocalizedText langSection="Budget_Meter" langKey="Coins_Available">Coins
                            Available</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-5 pb-4">
            <div class="col-2 pr-0 text-right d-flex flex-column justify-content-end">
                <span class="lato-bold font-size-12">{{budgetGroup.Amount <= 0 ? '' : getBudgetPercentage(budgetGroup.Amount, budgetGroup.CoinsAwarded)}} </span>
                    <span class="admin-budget-meter-text">
                        {{formatValue(budgetGroup.CoinsAwarded)}}
                        <span cvLocalizedText langSection="Budget_Meter" langKey="Coins_Awarded">Coins Awarded</span>
                    </span>
            </div>
            <div class="col-8">
                <div class="d-flex justify-content-center w-100 mb-2 bold" *ngIf="budgetGroup.Amount <= 0">
                    <span class="bold" cvLocalizedText langSection="Budget_Meter" langKey="No_Budget_Assigned">No Budget
                        Assigned</span>
                </div>
                <div class="progress rounded-0" style="height:32px">
                    <div class="progress-bar progress-bar-animated"
                        [ngClass]="getProgressClass((budgetGroup.CoinsAwarded/budgetGroup.Amount) * 100)"
                        style="height:32px; transition: 0.3s all ease;"
                        [ngStyle]="{ 'width': (budgetGroup.CoinsAwarded/budgetGroup.Amount) * 100 + '%' }">
                    </div>
                </div>
            </div>
            <div class="col-2 pl-0 text-left d-flex flex-column justify-content-end">
                <span class="lato-bold font-size-12">{{budgetGroup.Amount <= 0 ? '' : getBudgetPercentage(budgetGroup.Amount, budgetGroup.Amount - budgetGroup.CoinsAwarded)}} </span>
                    <span class="admin-budget-meter-text">
                        {{formatValue(getRemainingCoins(budgetGroup.Amount, budgetGroup.CoinsAwarded))}}
                        <span cvLocalizedText langSection="Budget_Meter" langKey="Remaining_Coins">Remaining coins</span>
                    </span>
            </div>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-center py-3" *ngIf="budget.budgetList.length > 0">
        <sol-button variant="basic" size="large" (click)="toggleDisplayBudgetDetails()">
            <span *ngIf="!displayBudgetDetails" cvLocalizedText langSection="Budget_Meter" langKey="See_More">See
                More</span>
            <span *ngIf="displayBudgetDetails" cvLocalizedText langSection="Budget_Meter" langKey="See_Less">See
                Less</span>
        </sol-button>
    </div>
</div>